import { Component, ElementRef, input, InputSignal, ViewChild } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
})
export class IconComponent {
  public path: InputSignal<string> = input.required();
  public width: InputSignal<number> = input(28);
  public height: InputSignal<number> = input(28);
  public color: InputSignal<string> = input('rgb(60,60,60)');

  @ViewChild('ref') iconRef!: ElementRef;
}
